/**
 * guarded-componentless-route-workaround.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";

/**
 * This class only exists as a workaround to Angular issue #12375.
 * (cf. https://github.com/angular/angular/issues/12375)
 * It is merely a blank primary outlet to ensure that Preactivation still
 * cues up a componentless route's guards for checking.
 */
@Component({
  template: `<router-outlet></router-outlet>`
})
export class GuardedComponentlessRouteWorkaroundComponent
{
  // Nothing
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/patches/guarded-componentless-route-workaround.component.ts